<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-6">
      <div class="bn-form-group">
        <label class="form-label" for="tipo">Tipo documento: </label>
        <select
          id="tipo"
          class="form-select"
          ngDefaultControl
          formControlName="tipo"
        >
          <option [ngValue]="null"></option>
          <option *ngFor="let item of tiposDocs" [value]="item.valor">
            {{ item.descricao }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-6">
      <div class="bn-form-group">
        <label class="form-label" for="arquivo">Arquivo: *</label>
        <bn-file-uploader
          *ngIf="!acompanhamentoDetalhe"
          id="arquivo"
          tipoPermitido=".pdf"
          form="true"
          autoUpload="false"
          quantidadeArquivosPorLinha="1"
          tamanhoMaximo="10"
          [descricao]="false"
          numeroMaximoArquivos="1"
          ngbTooltip="Anexar até 01 arquivo com no máximo 10Mbytes"
          placement="bottom"
          required
          (novoArquivoPendenteUpload)="novoArquivoPendenteUpload($event)"
          (arquivoPendenteUploadRemovido)="arquivoPendenteUploadRemovido($event)"
        >
        </bn-file-uploader>
        <div *ngIf="acompanhamentoDetalhe" class="input-group">
          <input type="text" class="form-control" id="arquivo" name="arquivo" formControlName="nomeAnexo" />
          <span class="input-group-text" (click)="exportarAnexo()"><i class="fa fa-download cursor-pointer" ngbTooltip="Exportar arquivo"></i></span>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col-6">
          <div class="bn-form-group">
            <label class="form-label" for="competencia">Competência: </label>
            <select id="competencia" class="form-select" ngDefaultControl formControlName="anoCompetencia"
                    [compareWith]="compararPorId">
              <option [ngValue]="null"></option>
              <option *ngFor="let item of anosCompetencia" [ngValue]="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col-6" *ngIf="acompanhamentoDetalhe">
          <div class="bn-form-group">
            <label class="form-label">Id. documento: </label>
            <input id="identificadorDocumento"
                   class="form-control"
                   ngDefaultControl
                   formControlName="identificadorDocumento"
                   [value]="formGroup.get('identificadorDocumento').value"
            >
          </div>
        </div>
      </div>
     <div class="row" *ngIf="exibePeriodo">
        <div class="col-6">
          <div class="bn-form-group">
            <label class="form-label" for="periodo">Período: {{ periodoEhObrigatorio ? "*" : "" }}</label>
            <select id="periodo" class="form-select" ngDefaultControl formControlName="periodo"
                    [compareWith]="compararPorId">
              <option [ngValue]="null"></option>
              <option *ngFor="let item of periodos" [value]="item.valor">
                {{ item.descricao }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="exibeMotivoRejeicao()" class="col-6">
      <label class="form-label" for="motivoEstado">Justificativa rejeição: </label>
      <textarea class="form-control" name="motivoEstado" id="motivoEstado" formControlName="motivoEstado"
                minlength="2" maxlength="1000" rows="3"></textarea>
    </div>
    <div *ngIf="exibeMotivoValidacao()" class="col-6">
      <label class="form-label" for="motivoEstado">Comentários validação: </label>
      <textarea class="form-control" name="motivoEstado" id="motivoEstado" formControlName="motivoEstado"
                minlength="2" maxlength="1000" rows="3"></textarea>
    </div>
  </div>
</form>
